<div class="comments-section">
  <div class="comments-header">
    <div>
      <div class="comments-count">
        <mat-icon>chat_bubble_outline</mat-icon>
        <span>{{ totalCommentsCount }} {{ 'translations.comments.count' | transloco }}</span>
      </div>

      <!-- <div class="sort-controls"> FIXME: consider types of sorting
        <mat-form-field appearance="outline" class="sort-select">
          <mat-select
            [value]="currentSort"
            (selectionChange)="onSortChange($event.value)"
            [placeholder]="'translations.comments.sort.placeholder' | transloco"
          >
            <mat-option *ngFor="let option of sortOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
    </div>

    <button
      mat-icon-button
      class="close-btn"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.close' | transloco"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="comments-list" *ngIf="comments.length > 0">
    <ptl-comment-list
      [comments]="comments"
      [momentId]="momentId"
      [currentUserId]="currentUserId"
      (commentUpdated)="onCommentUpdated($event)"
      (commentDeleted)="onCommentDeleted($event)"
      (commentLiked)="onCommentLiked($event.commentId, $event.isLiked)"
      (replyCreated)="onReplyCreated($event.reply, $event.parentCommentId)"
    >
    </ptl-comment-list>
  </div>

  <div class="empty-state" *ngIf="!isLoading && comments.length === 0">
    <mat-icon>chat_bubble_outline</mat-icon>
    <p>{{ 'translations.comments.actions.emptyState' | transloco }}</p>
  </div>

  <div class="sticky-comment-input">
    <ptl-comment-input
      [momentId]="momentId"
      [placeholder]="'translations.comments.actions.addComment' | transloco"
      (commentCreated)="onCommentCreated($event)"
    >
    </ptl-comment-input>
  </div>
</div>
